import React from 'react'
import Container from './micro-components/Container'

const InvalidatedCard: React.FC<{
  cheatScore?: number;
  cheatSummary?: string;
  detections: any[];
}> = ({ cheatScore, cheatSummary, detections }) => (
  <Container className="gap-4 bg-red-50 border border-red-100">
    <div className="flex items-center gap-2">
      <span className="text-red-600 font-semibold">Interview Invalidated</span>
      {cheatScore !== undefined ? (
        <span className="text-xs text-red-700 bg-red-100 px-2 py-1 rounded-full">
          Cheat score: {cheatScore}
        </span>
      ) : null}
    </div>
    {cheatSummary ? (
      <p className="text-sm text-red-700">{cheatSummary}</p>
    ) : null}
    {detections.length ? (
      <ul className="list-disc pl-5 text-sm text-red-700 space-y-1">
        {detections.map((d: any, idx: number) => (
          <li key={idx}>{d?.description || d}</li>
        ))}
      </ul>
    ) : null}
  </Container>
)

export default InvalidatedCard

